const settings = {
  appName: process.env.VUE_APP_NAME,
  endPoint: process.env.VUE_APP_ENPOINT_BACKEND,
  endPointCt: process.env.VUE_APP_ENPOINT_BACKEND_CT,
  endPointFP: process.env.VUE_APP_ENPOINT_BACKEND_FP,
  endPointGT: process.env.VUE_APP_ENPOINT_BACKEND_GT,
  endPointFppk: process.env.VUE_APP_ENPOINT_BACKEND_FPPK,
  endPointLM: process.env.VUE_APP_ENPOINT_BACKEND_LM,
  endPointMPR: process.env.VUE_APP_ENPOINT_MPR,
  endPointApp: process.env.VUE_APP_ENPOINT_APP,
  endPointAppPC: process.env.VUE_APP_ENPOINT_PETTY_CASH,
  endPointMiddleware: process.env.VUE_APP_ENPOINT_MIDDLEWARE,
  endPointLincMobile: process.env.VUE_APP_ENPOINT_LINCMOBILE,
  endPointProformaInvoice: process.env.VUE_APP_ENPOINT_PROFORMA_INVOICE,
  appType: process.env.VUE_APP_ENV,
  jwtSecret: process.env.VUE_APP_JWT_SECRET,
}

export default settings;